import { httpGET, httpPOST, httpPUT, httpDELETE } from './http'
import { getDefaultVitalInfo, getAgeRanges, reverseMapVital } from '@/constants/thresholds'
import config from '../../config'

// const API_URLS = {
//   ruleset: '/v1/rule-sets'
// }

const API_URL = 'https://assetanalysis-socketservices-mo7niavhjq-de.a.run.app/v1/rule-sets'

const ERROR_MESSAGES = {
  noName: 'Rule Set Name is Required',
  noRules: 'Rule Set Should have atleast one rule',
  noCondition: 'Please create valid equations to save the rule set.',
  formatCondition: 'All conditions should have proper format',
  duplicateName: 'Ruleset name is already taken',
  maxLengthExceeded: 'Maximum 30 characters allowed'
}

export const getAllRuleSets = (filter = { include: 'rules', where: { state: { neq: 'hidden' } } }) => {
  // return httpGET(`${API_URLS.ruleset}?filter=${JSON.stringify(filter)}`)
  return httpGET(`${API_URL}?filter=${JSON.stringify(filter)}`)
}

export const activateRuleSetByID = (id) => {
  return httpPUT(`${API_URL}/${id}/activate`, {})
}

export const getRuleSetByID = (id, filter = { include: 'rules' }) => {
  return httpGET(`${API_URL}/${id}??filter=${JSON.stringify(filter)}`)
}

export const saveSingleRuleSet = (id, data) => {
  if (id) {
    return httpPUT(`${API_URL}/${id}`, data)
  }
  return httpPOST(`${API_URL}`, data)
}

export const postSingleRuleSet = data => {
  return httpPOST(`${API_URL}`, data)
}

export const getThresholdAndROCValues = (threshold, pointer_events) => {
  return httpGET(`${config.API_URL_MS}/api/graph-service/graph/all?vital=${threshold}&previousevents=${pointer_events}`)
}

/**
 * Saves single rules set by rule set id (primary key) and rule id(forein key)
 * @param id - { String } primary key (rule set ID)
 * @param fk - { String } forien key (rule ID)
 * @param data - { Object } rule object
*/

export const saveRulesByRuleSetId = (id, fk, data) => {
  if (fk) {
    return httpPUT(`${API_URL}/${id}/rules/${fk}`, data)
  } else {
    // return httpPOST(`${API_URLS.ruleset}/${id}/rules`, data)
    return httpPOST(`${API_URL}/${id}/rules`, data)
  }
}

export const removeRulesByRuleSetId = (id, fk, data) => {
  return httpDELETE(`${API_URL}/${id}/rules/${fk}`)
}

export const getDockerImagesList = () => {
  return httpGET('https://dockerlistapi-mo7niavhjq-de.a.run.app/dockerImages/list')
}

export const processTabsData = rules => {
  let defaultSettingsRuleIndex = 0
  for (let i = 0; i < rules.length; i++) {
    const rule = rules[i]
    const { min, max } = rule?.rules[0]?.ranges[0] || {}
    if (rule?.name === 'Default Settings' && min === -1 && max === -1) {
      defaultSettingsRuleIndex = i
      break
    }
  }
  return [rules.splice(defaultSettingsRuleIndex, 1)[0], ...rules]
}

export const getRuleName = (rangeArr) => {
  if (rangeArr && rangeArr[0] && rangeArr[0].min === -1 && rangeArr[0].max === -1) return 'Default Settings'
  return rangeArr.reduce((prev, curr) => {
    return `${prev} ${curr.min}-${curr.max}`
  }, '')
}

export const defaultRule = (ageRanges) => {
  return ({
    name: getRuleName(ageRanges),
    expression: '',
    condition: '',
    temperature: getDefaultVitalInfo(),
    butane: getDefaultVitalInfo(),
    sulphurDioxide: getDefaultVitalInfo(),
    carbonDioxide: getDefaultVitalInfo(),
    ranges: ageRanges
  })
}

export const getNewTab = () => {
  return {
    name: '',
    state: '',
    rules: [
      defaultRule(getAgeRanges())
    ]
  }
}

export const updateCondition = (conidtion = [], index) => {
  if (conidtion[index + 2]) {
    conidtion.splice(index - 1, 4)
  } else if (conidtion[index - 2]) {
    conidtion.splice(index - 2, 4)
  } else if (conidtion.length === 3) {
    conidtion = []
  }

  return conidtion
}

const isDuplicateRulesetName = (ruleSet, ruleSetNames, ruleSetIndex, newRuleInitialised) => {
  let ruleSetNamesToCheck = ruleSetNames
  if (!newRuleInitialised || ruleSetIndex < ruleSetNames.length) {
    ruleSetNamesToCheck = [...ruleSetNames.slice(0, ruleSetIndex), ...ruleSetNames.slice(ruleSetIndex + 1)]
  }
  return ruleSetNamesToCheck.includes(ruleSet.name)
}

export const validateCurrentRuleSet = (ruleSet, ruleSetNames = [], ruleSetIndex, newRuleInitialised) => {
  const maxAllowedLength = 30
  if (!ruleSet.name) return ERROR_MESSAGES.noName
  if (ruleSet.name.length > maxAllowedLength) return ERROR_MESSAGES.maxLengthExceeded
  if (isDuplicateRulesetName(ruleSet, ruleSetNames, ruleSetIndex, newRuleInitialised)) return ERROR_MESSAGES.duplicateName
  if (!ruleSet.rules || !ruleSet.rules[0]) return ERROR_MESSAGES.noRules
  if (ruleSet.rules.some(rule => !rule.condition || !JSON.parse(rule.condition) || !JSON.parse(rule.condition).length)) return ERROR_MESSAGES.noCondition
  if (ruleSet.rules.some(rule => !!JSON.parse(rule.condition).reduce((prev, ele) => (ele === 'BO' && prev >= 0) ? prev + 1 : ele === 'BC' ? prev - 1 : ele === 'BO' ? 1 : prev, 0))) return ERROR_MESSAGES.formatCondition
}

export const populateExpression = (rule) => {
  const expression = JSON.parse(rule.condition).reduce((prev, ele) => {
    if (ele === 'BO') return `${prev} (`
    if (ele === 'BC') return `${prev} )`
    if (ele === '||') return `${prev} ||`
    if (ele === '&&') return `${prev} &&`
    if (reverseMapVital[ele]) return `${prev} (lt(${ele}, ${rule[reverseMapVital[ele]].min}))||(gt(${ele}, ${rule[reverseMapVital[ele]].max}))||(roc(${ele}, ${rule[reverseMapVital[ele]].time_frame},${rule[reverseMapVital[ele]].previous_events},${rule[reverseMapVital[ele]].roc}))`
    return prev
  }, '')
  return expression
}

export const mapThresholdGraphValues = ({ data, threshold, currentRule }) => {
  const xAxisData = []
  const yAxisData = []
  for (const dataPoint of data) {
    if (dataPoint?.vitals) {
      xAxisData.push(Math.round(dataPoint.vitals))
      yAxisData.push(dataPoint.density)
    } else {
      xAxisData.push((dataPoint.roc * 100).toFixed(0))
      yAxisData.push(dataPoint.cdf)
    }
  }
  let markPoints = [
    {
      xAxis: `${Math.round(currentRule.min)}`
    },
    {
      xAxis: `${Math.round(currentRule.max)}`
    }
  ]
  if (data && data[0] && data[0].roc) {
    markPoints = [
      {
        xAxis: `${currentRule.roc}`
      }
    ]
  }
  return {
    left: '0',
    right: '0',
    top: '10',
    width: 'auto',
    tooltip: {
      show: true,
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      },
      backgroundColor: '#fff',
      formatter: ([param]) => {
        return `${threshold.key} : ${param.axisValue} \n\r
        Instances : ${param.data}`
      },
      textStyle: {
        fontSize: 12
      },
      extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); color: #000'
    },
    xAxis: {
      type: 'category',
      data: xAxisData
    },
    yAxis: {
      type: 'value',
      min: 0
    },
    series: [{
      data: yAxisData,
      type: 'line',
      smooth: true,
      areaStyle: {
        color: '#5764B3a0'
      },
      itemStyle: {
        color: '#5764B3'
      },
      markLine: {
        symbol: ['none', 'none'],
        lineStyle: {
          type: 'solid',
          color: '#E89171',
          width: 2
        },
        data: markPoints
      }
    }]
  }
}

export const getDeviceList = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      const data = [{
        checked: false,
        deviceId: {
          value: '89hygd7-410f-4892-987b-bf5eaaf6991f'
        },
        deviceName: {
          value: 'Device 3'
        }
      },
      {
        checked: false,
        deviceId: {
          value: '90hygd7-410f-4892-987b-bf5eaaf6991f'
        },
        deviceName: {
          value: 'Device 4'
        }
      }]
      resolve(data)
    }, 1000)
  })
  return promise
}

export const getDeployedDeviceList = (tabName) => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      const defaultSetting = [{
        checked: false,
        deviceId: {
          value: 'b2fa9cbc-410f-4892-987b-bf5eaaf6991f'
        },
        deviceName: {
          value: 'Device 1'
        },
        deployedBy: {
          value: 'Jason Troxel'
        },
        deployedStatus: {
          value: 'Success'
        }
      },
      {
        checked: false,
        deviceId: {
          value: 'a2fa9cbc-410f-4892-987b-bf5eaaf6991f'
        },
        deviceName: {
          value: 'Device 2'
        },
        deployedBy: {
          value: 'John Doe'
        },
        deployedStatus: {
          value: 'Success'
        }
      }]
      const other = [{
        checked: false,
        deviceId: {
          value: '123'
        },
        deviceName: {
          value: 'Device 11'
        },
        deployedBy: {
          value: 'Jas'
        },
        deployedStatus: {
          value: 'Success'
        }
      },
      {
        checked: false,
        deviceId: {
          value: '124'
        },
        deviceName: {
          value: 'Device 12'
        },
        deployedBy: {
          value: 'Joe'
        },
        deployedStatus: {
          value: 'Success'
        }
      },
      {
        checked: false,
        deviceId: {
          value: '125'
        },
        deviceName: {
          value: 'Device 13'
        },
        deployedBy: {
          value: 'Mark'
        },
        deployedStatus: {
          value: 'Success'
        }
      }]
      if (tabName === 'Default Settings') {
        resolve(defaultSetting)
      } else {
        resolve(other)
      }
    }, 1000)
  })
  return promise
}
